export default __webpack_public_path__ + "media/images/backgrounds/white-faq-bar-667092ec15e028ed07a8cdf37744fbd2.svg";